/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_140_TitleInputs */

const en_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incurved Chrysanthemum`)
};

const ar_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة الأقحوان المقوس`)
};

const de_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungekrümmte Chrysantheme`)
};

const es_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crisantemo incurvado`)
};

const fr_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrysanthème d'automne`)
};

const it_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crisantemo Incurvato`)
};

const ja_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管物菊`)
};

const ko_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내향형 국화`)
};

const pt_br_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crisântemo encurvado`)
};

const ru_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хризантема садовая`)
};

const th_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบญจมาศกลีบงุ้ม`)
};

const tr_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kıvrımlı Kasımpatı`)
};

const zh_cn_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卷瓣菊花`)
};

const zh_tw_tree_type_140_title = /** @type {(inputs: Tree_Type_140_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卷瓣菊花`)
};

/**
* | output |
* | --- |
* | "Incurved Chrysanthemum" |
*
* @param {Tree_Type_140_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_140_title = /** @type {((inputs?: Tree_Type_140_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_140_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_140_title(inputs)
	if (locale === "ar") return ar_tree_type_140_title(inputs)
	if (locale === "de") return de_tree_type_140_title(inputs)
	if (locale === "es") return es_tree_type_140_title(inputs)
	if (locale === "fr") return fr_tree_type_140_title(inputs)
	if (locale === "it") return it_tree_type_140_title(inputs)
	if (locale === "ja") return ja_tree_type_140_title(inputs)
	if (locale === "ko") return ko_tree_type_140_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_140_title(inputs)
	if (locale === "ru") return ru_tree_type_140_title(inputs)
	if (locale === "th") return th_tree_type_140_title(inputs)
	if (locale === "tr") return tr_tree_type_140_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_140_title(inputs)
	return zh_tw_tree_type_140_title(inputs)
});